import { produce } from "immer";
import { set as _set } from "lodash";

import { IMiddleware, TSource } from "../interfaces";

export const ObjectMiddleware: IMiddleware = {
  check(datasource: TSource) {
    return datasource.type === "scalar" && datasource.dataType === "object";
  },
  create(datasource) {
    if (!ObjectMiddleware.check(datasource)) return;
  },
  set(root, path, value, ctx) {
    const { value: state } = ctx;
    const datasource = state.sources[root];

    if (!datasource || !ObjectMiddleware.check(datasource)) return;

    const newValue = produce(state, (draft) => {
      _set(
        draft.sources,
        `${root}.value${path.length > 0 ? "." : ""}${path.join(".")}`,
        value
      );
    });

    ctx.next(newValue);
  },
};
